import { Component, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core'
import { Address } from 'depoto-core/src/entities'
import { CoreService } from '../../../services'
import { OrderDetailService } from '../../../services/order-detail.service'
import { copyAddressForOrder, SchemaUtil } from '../../../utils'

@Component({
  selector: 'order-address-page',
  templateUrl: './order-address-page.component.html',
  styleUrls: ['./order-address-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderAddressPageComponent implements OnChanges, OnInit {
  shippingAddresses: Array<Address | Partial<Address>> = []
  invoiceAddresses: Array<Address | Partial<Address>> = []

  constructor(
    private core: CoreService,
    public orderDetailService: OrderDetailService
  ) {}

  async ngOnInit() {
    this.orderDetailService.loading = true
    if (this.orderDetailService.order?.customer) {
      this.shippingAddresses = (this.orderDetailService.order.customer.addresses ?? []).filter(
        a => a?.isStored
      ) as Array<Address | Partial<Address>>
      this.invoiceAddresses = (this.orderDetailService.order.customer.addresses ?? []).filter(
        address => address?.isStored && address?.isBilling === true
      ) as Array<Address | Partial<Address>>
    }
    this.orderDetailService.loading = false
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (
      (this.order.customer.addresses === null || this.order.customer.addresses === undefined) &&
      this.orderDetailService.order.customer
    ) {
      this.orderDetailService.order.customer.addresses = await this.core.services.address.getList(
        {
          filters: { customer: this.orderDetailService.order.customer.id },
        },
        SchemaUtil.address
      )
    }
    if (this.order.customer.addresses?.length) {
      this.shippingAddresses = (this.orderDetailService.order.customer.addresses ?? []).filter(
        a => a?.isStored
      ) as Array<Address | Partial<Address>>
      this.invoiceAddresses = (this.orderDetailService.order.customer.addresses ?? []).filter(
        a => a?.isStored && a?.isBilling
      ) as Array<Address | Partial<Address>>
    }
  }

  public selectAddress(address: Address, type: 'invoice' | 'shipping'): void {
    if (type === 'invoice') {
      this.orderDetailService.order.invoiceAddress = copyAddressForOrder(address, true)
      this.orderDetailService.storeInvoiceAddressOnCustomer = false
      this.orderDetailService.isEditedAddress = true
      if (this.orderDetailService.isShippingAddressSameAsInvoice) {
        this.orderDetailService.order.shippingAddress = this.orderDetailService.order.invoiceAddress
      }
    } else if (type === 'shipping') {
      this.orderDetailService.order.shippingAddress = copyAddressForOrder(address, false)
      this.orderDetailService.storeShippingAddressOnCustomer = false
      this.orderDetailService.isEditedAddress = true
    }
  }

  public invoiceShippingRelationChange(value: boolean): void {
    this.orderDetailService.isShippingAddressSameAsInvoice = value
    if (this.orderDetailService.isShippingAddressSameAsInvoice) {
      this.orderDetailService.order.shippingAddress = this.orderDetailService.order.invoiceAddress
      this.orderDetailService.storeShippingAddressOnCustomer = false
      this.orderDetailService.isEditedAddress = true
    } else {
      this.orderDetailService.order.shippingAddress = new Address()
      this.orderDetailService.storeShippingAddressOnCustomer = false
      this.orderDetailService.isEditedAddress = true
    }
  }

  public shouldShowStoreAddressOnCustomerToggle(): boolean {
    return !!(this.orderDetailService.isCreating && this.orderDetailService.order?.customer?.id)
  }

  get order() {
    return this.orderDetailService.order
  }
}
